import React from 'react';
import styles from './About.module.css';

export default function About() {
  return (
    <section className={styles.about} id="about">
      <h2>About Me</h2>
      <p>
        I’m <strong>Tsion Tesfaye</strong>, a 4th-year <strong>Software Engineering student</strong> and passionate <strong>Full-Stack Developer</strong> from Ethiopia.
        I love crafting beautiful and functional web applications that solve real-world problems. 
        Whether it’s frontend design or backend logic, I bring both creativity and logic to the table.
      </p>
      <p>
        I believe in continuous learning, teamwork, and building technology that uplifts lives.
        Let’s create something amazing together.
      </p>
    </section>
  );
}
